export default function getUserLanguage(userLanguage: string | null): string {
    if (userLanguage) {
        if (userLanguage.startsWith('es')) {
            return 'es-ES';
        }
        if (userLanguage.startsWith('en')) {
            return 'en-US';
        }
        return 'pt-BR';
    }
    return 'pt-BR';
}
